/**
 * baseAdvance — may a finished save move the 3-way merge BASE?
 *
 * Walter 2026-09-19. His sync log, the line that named this bug:
 *
 *   21:09:13  adopt-decision w=iqubs/pwa action=adopt    base=33611 local=33611 server=33610
 *   21:09:17  adopt-decision w=iqubs/pwa action=conflict base=33611 local=33610 server=33247 clashes=1
 *
 * Four seconds apart. The window ADOPTED 33610 — so its base became 33610 —
 * and then decided against a base of 33611, one version OLDER than its own
 * buffer. A base behind the buffer is impossible by definition: base is "the
 * server content our buffer descends from". With a false ancestor the merge
 * reads edits nobody made and bands; it can also keep the wrong side.
 *
 * How it gets behind: a save that was already in flight finishes AFTER an
 * incoming version was adopted, and `flushSave` ends with
 * `setBase(patch.content)` — the text that save wrote, which by then is the
 * older one. The save's own base was correct when it started; it is simply no
 * longer the newest thing this window knows.
 *
 * This is the sibling of the 2026-09-14 serial-save fix (#231): that one
 * stopped a save racing a SAVE; this one stops a save racing an ADOPTION.
 *
 * The rule is one line and it only ever SKIPS an update: advance the base to
 * what we just wrote unless something else moved it while we were writing —
 * in which case that something is an adoption of a newer version, and its
 * base is the right one. The next snapshot reconciles either way.
 */
export function shouldAdvanceBase(baseAtStart, baseNow) {
  return String(baseAtStart ?? '') === String(baseNow ?? '');
}

export default shouldAdvanceBase;
